<template>
	<el-container>
		<el-main style="width: 70%;">
			<div style="margin-bottom: 30px;display: flex;justify-content: space-between;align-items: center;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">自定义话术</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<div>
				<el-button type="text" size="mini" style="margin-right: 12px;color: orangered;">请先选择科室</el-button>
				<el-select v-model="department" size="mini" placeholder="请选择科室" @change="changeDep" style="margin-right: 12px;">
					<el-option v-for="(item , index) in departmentList" :key="index" :label="item.name" :value="item.depType"></el-option>
				</el-select>
				
				<el-input v-model="searchContent" :disabled="!department" @input="searchTopicList" placeholder="请输入长度至少为2的搜索内容" size="mini" style="width: 200px;"></el-input>
			</div>
			
			<!--话术列表-->
			<div class="talkListBox" v-loading="diaLoading">
				<dl v-for="(item,index) in talkTopicList" :key="index">
					<dt @click="showList(item,index)">
						<i :class="onIndex == index?'el-icon-arrow-up':'el-icon-arrow-down'" style="color: #333;"></i>
						{{item.name}}
					</dt>
					<div v-if="onIndex == index" style="max-height: 400px;overflow-y: auto;cursor:default" v-loading="diaLoading">
						<dd v-for="(items,indx) in item.customUtterVoList" :key="indx"
						:class="onIndexs == indx?'active':''" @click="showClass(indx)"
						@contextmenu.prevent="showDet(item,items,indx,index)">
							<span class="title">{{items.bsId}}</span>
							<span v-show="items.status == 1 && items.customUtterList != null" class="log">[已改话术]</span>
							<span>
								{{items.status == 1 && items.customUtterList != null ? items.customUtterList[0] : items.content}}
							</span>
							
						</dd>
					</div>
					
					<!-- <div v-if="onIndex == index" style="max-height: 400px;overflow-y: auto;cursor:default">
						<dd v-for="(items,indx) in item.talkTitleList" :key="items.id"
							:class="onIndexs == indx?'active':''" @click="showClass(indx)"
							@contextmenu.prevent="showDet(item,items,indx,index)">
							<div v-if="items.talkLibraryList && items.talkLibraryList.length>0">
							<div v-if="items.talkTitleList && items.talkTitleList.length>0">
								<span class="title">{{items.titleName}}</span>
								<span class="title">{{items.bsId}}</span>
								<span v-show="items.modifyStatus == 1" class="log">[已改话术]</span>
								<span v-show="items.status == 1" class="log">[已改话术]</span>
								<span>
									{{items.talkLibraryList[0].modifiedContent?items.talkLibraryList[0].modifiedContent:items.talkLibraryList[0].talkContent}}
									{{items.content}}
								</span>
							</div>
						</dd>
					</div> -->
				</dl>
			</div>
			<el-dialog title="更新话术" :visible.sync="addQuery" custom-class="dialog" :close-on-click-modal="false"
				:close-on-press-escape="false" width="50%" center v-loading="diaLoading">
				<el-form label-width="90px">
					<el-form-item label="" style="text-align: right;margin-bottom: 10px;">
						<el-select v-model="changeItem" placeholder="选择插入变量" size="mini" clearable
							@change="choChangeItem">
							<el-option v-for="item in changeItemList" :key="item.varName" :label="item.name"
								:value="item.varName">
							</el-option>
						</el-select>
					</el-form-item>
					
					<div v-if="showDefaultTalk" class="default_box" style="display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;">
						<span style="white-space: nowrap;width: 10%;margin-top: 5px;">默认话术:</span>
						<div class="talk_list" style="width: 90%;display: flex;flex-direction: column;justify-content: flex-start;">
							<div v-for="(item,index) in talkList" :key="index" style="margin-left: 10px;margin-top: 5px;display: flex;justify-content: space-between;align-items: flex-start;">
								<span>{{index+1}}.{{item.content}}</span>
								<a style="margin-right: 12px;margin-left: 12px;white-space: nowrap;color: #0048AB;" @click="importTalk(item)">引用</a>
							</div>
						</div>
					</div>
					
					<div class="custom_box" style="display: flex;flex-direction: row;align-items: flex-start;justify-content: flex-start;margin-top: 20px;">
						<span style="white-space: nowrap;width: 10%;margin-top: 5px;">自定义话术:</span>
						<div class="talk_list" style="width: 90%;display: flex;flex-direction: column;justify-content: flex-start;">
							<div v-for="(item,index) in customTalkList" :key="index" style="margin-left: 10px;margin-top: 5px;display: flex;justify-content: space-between;align-items: flex-start;">
								<el-input :id="'textInput_'+index" v-model="item.content" size="mini" @focus="getInputIndex(index)"></el-input>
								<a style="margin-right: 12px;white-space: nowrap;color: #0048AB;margin-left: 12px;" @click="deleteCustomTalk(index)">删除</a>
							</div>
						</div>
						
					</div>
					
					<el-form-item label-width="0" style="text-align: center;margin-top: 12px;">
						<el-button @click="addCustomTalk" size='mini' type='primary'>添加</el-button>
					</el-form-item>
					<!-- <div v-for="(item,index) in talkList" :key="index">
						<el-form-item label="默认话术:" style="margin-bottom: 10px;">
							<el-input v-model="item.talkContent" type="textarea" :disabled="true" rows="2"
								style="width: 95%"></el-input>
						</el-form-item>
						
						
						<el-form-item label="自定义话术:" style="margin-bottom: 10px;">
							<el-input :id="'textInput_'+index" @focus="getInputIndex(index)"
								v-model="item.modifiedContent" type="textarea" rows="2" style="width: 95%" clearable>
							</el-input>
							<a style="color: #5A9CF8;position: absolute;right: -10px;top:0;font-size: 12px;"
								@click="clear(index)">清空</a>
						</el-form-item>
						
					</div> -->
					<el-form-item label-width="0" style="text-align: center;margin-top: 12px;">
						<el-button @click="addQuery = false" size='mini'>取 消</el-button>
						<el-button type="primary" size='mini' @click="updateCustomUtter">确 定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</el-main>
	</el-container>
</template>

<script>
	var textInput;
	var textIndex;
	import {MessageBox} from 'element-ui';
	export default {
		data() {
			return {
				talkTopicList: [],
				addQuery: false,
				talkCont: '',
				talkUpdateCont: '',
				talkId: '',
				onIndex: null,
				onIndexs: null,
				diaLoading: true,
				changeItem: '',
				changeItemList: [],
				talkList: [],
				topIndex: '',
				secIndex: '',
				topId: '',
				secName: '',
				departmentList: [],
				department: 1,
				searchContent: null,
				showDefaultTalk: false,
				customTalkList: [],
				titleId:null
			}
		},

		created() {},

		mounted() {
			this.getItemList();
			// this.getTalksList()
			this.getDepartmentList()
			// this.getUtterTopicList()
			this.$nextTick(() => {
				
				this.getUtterTopicList()
				
			})
			
		},

		methods: {
			//获取变量
			async getItemList() {
				var api = "/manager/bisvariable/getbisvariable";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.changeItemList = response.data;
				}
			},
			
			// 获取科室列表
			async getDepartmentList(){
				var api = "/manager/depType/getDepType"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						
					},
				})
				console.log("*****querySelect getDepType*****",response)
				this.departmentList = response.data
			},
			
			//选择科室
			changeDep(val){
				console.log("changeDep" , val)
				this.getUtterTopicList()
				this.onIndex = null
				this.onIndexs = null
			},
			
			//获取话术topic列表
			async getUtterTopicList() {
				var api = "/manager/utterTopic/getUtterTopicList";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType: this.department
					},
				});
				console.log("*****querySelect getUtterTopicList*****", response);
				if (response.resultCode == 10000) {
					this.diaLoading = false;
					this.talkTopicList = response.data;
					console.log("this.talkTopicList",this.talkTopicList)
					if(this.talkTopicList == 0){
						this.$message.success("该科室暂无数据，请选择其他科室");
					}
				} else {
					this.diaLoading = false;
					this.$message.error(response.desc);
				}
			},
			
			showList(item, index) {
				if (this.onIndex == index) {
					this.onIndex = null;
				} else {
					this.onIndex = index;
					if(this.talkTopicList[this.onIndex]['customUtterVoList'].length == 0){
						this.diaLoading = true;
						this.getUtters(item)
					}
				}
				
			},
			
			async getUtters(item) {
				
				var api = "/manager/utter/getUtters";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						topicId: item.id,
					},
				});
				console.log("*****querySelect getUtters*****", response);
				if (response.resultCode == 10000) {
					this.talkTopicList[this.onIndex]['customUtterVoList'] = response.data
					this.diaLoading = false;
					console.log("this.talkTopicList",this.talkTopicList)
				} else {
					this.diaLoading = false;
					this.$message.error(response.desc);
				}
				
			},
			
			//查看详情
			showDet(item,items, index, topIndex) {
				
				this.topIndex = topIndex;
				this.secIndex = index;
				this.topId = item.id;
				this.secName = items.titleName;
				this.titleId = items.titleId
				console.log("items.topicId, items.titleId", items.topicId, items.titleId)
				this.diaLoading = true
				if(items.status == 0){
					this.getUtterByTopicAndTitle(items.topicId, items.titleId)
					this.customTalkList = []
					this.showDefaultTalk = true
				}else{
					this.getUtterByTopicAndTitle(items.topicId, items.titleId)
					this.getCustomUtterList(items.topicId, items.titleId)
					this.showDefaultTalk = true
				}
				// this.talkList = item.talkLibraryList;
				this.changeItem = '';
				this.addQuery = true;
			},
			
			
			// 查询默认话术
			async getUtterByTopicAndTitle(topicId, titleId) {
				var api = "/manager/utter/getUtterByTopicAndTitle";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						topicId: topicId,
						titleId: titleId
					},
				});
				console.log("*****querySelect getUtterByTopicAndTitle*****", response);
				if(response.resultCode == 10000){
					this.talkList = response.data
					this.diaLoading = false
				}else{
					this.diaLoading = false
					this.$message.error(response.desc);
				}
			},
			
			// 查询自定义话术
			async getCustomUtterList(topicId, titleId) {
				var api = "/manager/customUtter/getCustomUtterList";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						topicId: topicId,
						titleId: titleId
					},
				});
				console.log("*****querySelect getCustomUtterList*****", response);
				if(response.resultCode == 10000){
					this.diaLoading = false
					this.customTalkList = response.data
				}else{
					this.diaLoading = false
					this.$message.error(response.desc);
				}
			},
			
			
			// 引用默认话术
			importTalk(item) {
				console.log("importTalk",item)
				this.customTalkList.push(JSON.parse(JSON.stringify(item)))
			},
			
			// 增加自定义话术
			addCustomTalk(){
				this.customTalkList.push({
					content:''
				})
			},
			//选择变量
			choChangeItem(val) {
				let insert = textInput.selectionStart;
				// this.talkList[textIndex].modifiedContent = this.talkList[textIndex].modifiedContent.substr(0, insert) +
				// 	val + this.talkList[textIndex].modifiedContent.substr(insert);
					
				this.customTalkList[textIndex].content = this.customTalkList[textIndex].content.substr(0, insert) + val + this.customTalkList[textIndex].content.substr(insert)
				textInput.focus();
			},
			getInputIndex(index) {
				textInput = document.getElementById('textInput_' + index);
				textIndex = index;
			},
			
			// 删除自定义话术
			deleteCustomTalk(index) {
				MessageBox.alert("是否确认删除", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(() => {
					this.customTalkList.splice(index , 1)
					this.$message.success('删除成功!')
				}).catch(() => {
					this.$message.info('取消删除!')
				})
			},
			
			async updateCustomUtter(){
				
				let updateTalkList = []
				for(let i = 0, len = this.customTalkList.length; i < len; i++){
					updateTalkList.push(this.customTalkList[i].content.replace(/\s+/g,""))
				}
				
				if(updateTalkList.indexOf("") == -1){
					var api = "/manager/utter/updateCustomUtter";
					const response = await this.util.postRequest({
						url: api,
						method: "POST",
						data: {
							titleId: this.titleId,
							utterList: updateTalkList
						},
					});
					console.log("*****queryUpdate updateCustomUtter*****", response);
					if(response.resultCode == 10000){
						this.$message.success('更新成功!')
						this.addQuery = false
						this.diaLoading = true
						this.onIndex = null
						this.getUtterTopicList()
						
					}else{
						this.$message.error(response.desc);
					}
				}else{
					this.$message.error('自定义话术不能为空，请确认后再进行保存');
				}
			},
			
			// 模糊搜索
			searchTopicList(val){
				console.log("searchTopicList val" , val)
				if(val.length>=2){
					this.getFuzzyMatchingUtters()
				}else if(val == ''){
					this.getUtterTopicList()
				}
			},
			async getFuzzyMatchingUtters(){
				var api = "/manager/utter/getFuzzyMatchingUtters";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						departmentType: this.department,
						content: this.searchContent,
					},
				});
				console.log("*****querySelect getFuzzyMatchingUtters*****", response);
				this.talkTopicList = response.data
			},
			
			
			
		// 	//话术列表
		// 	async getTalksList() {
		// 		var api = "/manager/talk/getTalks";
		// 		const response = await this.util.postRequest({
		// 			url: api,
		// 			method: "POST",
		// 			data: {
		// 				current: 1,
		// 				talkId: '',
		// 				size: 999
		// 			},
		// 		});
		// 		console.log("*****querySelect *****", response);
		// 		if (response.resultCode == 10000) {
		// 			this.diaLoading = false;
		// 			this.talkTopicList = response.data.talkTopicList;
		// 		} else {
		// 			this.diaLoading = false;
		// 			this.$message.error(response.desc);
		// 		}
		// 	},
			
			
			
		// 	//话术详情
		// 	async getTalksDet(id, title) {
		// 		var api = "/manager/talk/getTalkDetail";
		// 		const response = await this.util.postRequest({
		// 			url: api,
		// 			method: "POST",
		// 			data: {
		// 				id: id,
		// 				title: title
		// 			},
		// 		});
		// 		console.log("*****querySelect *****", response);
		// 		if (response.resultCode == 10000) {
		// 			this.talkList = response.data.talkLibraryVoList;
		// 			//this.talkList = response.data.talkTopicList[0].talkTitleList[0].talkLibraryList;
		// 		} else {
		// 			this.$message.error(response.desc);
		// 		}
		// 	},
			
			
			
		// 	//查询更新后的数据
		// 	async getTalksUpdate(id, title) {
		// 		var api = "/manager/talk/getTalkDetail";
		// 		const response = await this.util.postRequest({
		// 			url: api,
		// 			method: "POST",
		// 			data: {
		// 				id: id,
		// 				title: title
		// 			},
		// 		});
		// 		console.log("*****querySelect *****", response);
		// 		if (response.resultCode == 10000) {
		// 			this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].talkLibraryList[0].modifiedContent =
		// 				response.data.talkLibraryVoList[0].modifiedContent;
		// 			this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].talkLibraryList[0].talkContent =
		// 				response.data.talkLibraryVoList[0].talkContent;
		// 			this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].modifyStatus = response.data
		// 				.modifyStatus;
		// 		} else {
		// 			this.$message.error(response.desc);
		// 		}
		// 	},
		// 	//话术更新保存
		// 	async getTalksDetSave() {
		// 		console.log(this.talkList);
		// 		var talkLibrarys = [];
		// 		for (var i = 0; i < this.talkList.length; i++) {
		// 			var item = {
		// 				id: this.talkList[i].id,
		// 				modifiedContent: this.talkList[i].modifiedContent
		// 			}
		// 			talkLibrarys.push(item);
		// 		}
		// 		var api = "/manager/talk/updateTalkById";
		// 		const response = await this.util.postRequest({
		// 			url: api,
		// 			method: "POST",
		// 			data: talkLibrarys,
		// 		});
		// 		console.log("*****querySelect *****", response);
		// 		if (response.resultCode == 10000) {
		// 			this.$message.success("更新成功");
		// 			this.getTalksUpdate(this.topId, this.secName);
		// 			/* this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].talkLibraryList[0].modifiedContent=this.talkList[0].modifiedContent;
		// 			 this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].talkLibraryList[0].talkContent=this.talkList[0].talkContent;
		// 			 var count = 0;
		// 			 for(var j = 0; j<this.talkList.length;j++){
		// 			   if(this.talkList[j].modifiedContent){
		// 			     count +=1;
		// 			   }
		// 			 }
		// 			 if(count>0){
		// 			   this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].modifyStatus = 1;
		// 			 }else{
		// 			   this.talkTopicList[this.topIndex].talkTitleList[this.secIndex].modifyStatus = 0;
		// 			 }*/
		// 			this.addQuery = false;
		// 		} else {
		// 			this.$message.error(response.desc);
		// 		}
		// 	},
		// 	async talksDetDel(item) {
		// 		console.log(item);
		// 		var api = "/manager/talk/delTalkById";
		// 		const response = await this.util.postRequest({
		// 			url: api,
		// 			method: "POST",
		// 			data: {
		// 				id: item.id,
		// 			},
		// 		});
		// 		console.log("*****querySelect *****", response);
		// 		if (response.resultCode == 10000) {
		// 			this.$message.success("删除成功");
		// 			this.getTalksList();
		// 		} else {
		// 			this.$message.error(response.desc);
		// 		}
		// 	},
		
			
			
			
			
			clear(index) {
				this.customTalkList[index].content = '';
			},
			showClass(indx) {
				this.onIndexs = indx;
			}
		}
	}
</script>

<style scoped="scoped">
	.custom_div {
		margin-bottom: 0.9375rem;
	}

	.custom_div>span {
		font-size: 0.875rem;
		color: #444444;
	}

	.talkListBox {
		width: 100%;
		overflow: hidden;
		margin-top: 12px;
	}

	.talkListBox dl {
		overflow: hidden;
		margin-bottom: 10px;
	}

	.talkListBox dl dt {
		width: 100%;
		height: 30px;
		background: #eee;
		padding: 0 20px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		color: darkgreen;
	}

	.talkListBox dl dd.active {
		background: #f5f5f5;
	}

	.talkListBox dl dd {
		padding: 5px 20px;
		overflow: hidden;
		font-size: 13px;
		line-height: 25px;
		font-weight: normal;
		border-bottom: 1px #ddd dotted;
	}

	.talkListBox dl dd .title {
		color: #5A9CF8;
		font-weight: normal;
	}

	.talkListBox dl dd .log {
		color: blue;
	}
</style>
